import React, { useMemo } from "react";
import { Bar } from "react-chartjs-2";
import { useTranslation } from "react-i18next";

const WastageAfterIssueChart = ({ data }) => {
  const { t } = useTranslation();

  const chartData = useMemo(() => {
    if (!data) return null;

    return {
      labels: data.hospitals.map((hospital) => t(hospital)),
      datasets: [
        {
          label: t("Units Returned"),
          data: data.unitsReturned,
          backgroundColor: "#dc3545",
          borderColor: "#dc3545",
          borderWidth: 1,
          barThickness: 40,
          borderRadius: 4,
        },
      ],
    };
  }, [data, t]);

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    legend: {
      display: false,
    },
    scales: {
      yAxes: [
        {
          ticks: {
            beginAtZero: true,
            max: 40,
            stepSize: 10,
            fontColor: "#666",
          },
          gridLines: {
            color: "rgba(0, 0, 0, 0.1)",
          },
          scaleLabel: {
            display: true,
            labelString: t("Units Returned"),
            fontColor: "#666",
          },
        },
      ],
      xAxes: [
        {
          ticks: {
            fontColor: "#666",
          },
          gridLines: {
            display: false,
          },
        },
      ],
    },
    tooltips: {
      callbacks: {
        label: (tooltipItem) => {
          return `${t("Units Returned")}: ${tooltipItem.yLabel}`;
        },
      },
    },
  };

  if (!chartData) {
    return <p className="text-center mt-3">{t("No data available")}</p>;
  }

  return (
    <div style={{ minHeight: "280px", position: "relative" }}>
      <Bar data={chartData} height={280} options={options} />
    </div>
  );
};

export default WastageAfterIssueChart;
